// بيانات المنتجات لصفحة المنتجات
export const productsData = [
  {
    id: 1,
    title: "فستان عصري - موديل A1",
    price: "",
    description: "فستان أنيق مناسب لجميع المناسبات، خامة عالية الجودة.",
    image: "/img/photo_2026-01-25_07-07-08.jpg",
    colors: [
      { name: "أحمر", value: "#FF0000", hex: "#FF0000", image: "/img/photo_2026-01-25_07-07-42.jpg" },
      { name: "أسود", value: "#000000", hex: "#000000", image: "/img/photo_2026-01-25_07-07-45.jpg" }
    ],
    features: [
      "خامة قطنية ناعمة",
      "تصميم عصري وجذاب",
      "متوفر بمقاسات مختلفة",
      "سهل الغسل والكي"
    ]
  },
  {
    id: 2,
    title: "طقم كاجوال - موديل A2",
    price: "",
    description: "طقم مريح وعملي للاستخدام اليومي.",
    image: "/img/photo_2026-01-25_07-07-23.jpg",
    colors: [
      { name: "أزرق", value: "#0000FF", hex: "#0000FF", image: "/img/photo_2026-01-25_07-07-23.jpg" },
      { name: "رمادي", value: "#808080", hex: "#808080", image: "/img/photo_2026-01-25_07-08-39.jpg" }
    ],
    features: [
      "مريح جداً في اللبس",
      "ألوان ثابتة لا تبهت",
      "مناسب للخروجات اليومية",
      "جودة تصنيع عالية"
    ]
  },
  {
    id: 3,
    title: "عباءة أنيقة - موديل A3",
    price: "",
    description: "عباءة بتصميم راقي وتفاصيل مميزة.",
    image: "/img/photo_2026-01-25_07-07-33.jpg",
    colors: [
      { name: "أسود ملكي", value: "#000000", hex: "#000000", image: "/img/photo_2026-01-25_07-07-54.jpg" },
      { name: "ابيض", value: "#FFFFFF", hex: "#FFFFFF", image: "/img/photo_2026-01-25_07-07-36.jpg" }
    ],
    features: [
      "قماش فاخر",
      "تطريز يدوي ناعم",
      "قصة مريحة",
      "مثالية للمناسبات الرسمية"
    ]
  },
  {
    id: 4,
    title: "بلوزة شيك - موديل A4",
    price: "",
    description: "بلوزة ناعمة بألوان صيفية مبهجة.",
    image: "/img/photo_2026-01-25_07-07-39.jpg",
    colors: [
      { name: "أبيض", value: "#FFFFFF", hex: "#FFFFFF", image: "/img/photo_2026-01-25_07-07-39.jpg" },
      { name: "وردي", value: "#FFC0CB", hex: "#FFC0CB", image: "/img/photo_2026-01-25_07-07-42.jpg" }
    ],
    features: [
      "خفيفة وباردة",
      "تصميم أنثوي رقيق",
      "تتناسب مع الجينز والتنانير",
      "سهلة العناية"
    ]
  }
];

// بيانات العروض الخاصة
export const specialOffers = [
  {
    id: 1,
    title: "عرض المجموعة الكاملة (6 قطع)",
    text: "احصلي على مجموعة من 6 قطع متنوعة بألوان رائعة بسعر خاص جداً!",
    price: "",
    images: [
      "/img/photo_2026-01-25_07-07-08.jpg",
      "/img/photo_2026-01-25_07-07-12.jpg",
      "/img/photo_2026-01-25_07-07-23.jpg",
      "/img/photo_2026-01-25_07-07-27.jpg",
      "/img/photo_2026-01-25_07-07-33.jpg",
      "/img/photo_2026-01-25_07-07-36.jpg"
    ]
  },
  {
    id: 2,
    title: "توصيل مجاني",
    text: "توصيل مجاني عند طلب أكثر من مجموعة 6 قطع!",
    image: "/img/NanoBanana-2026-01-25(1)(1).png"
  }
];

// دالة لإنشاء رسالة واتساب للمنتج
export const createProductWhatsappMessage = (product, selectedColor, address = "") => {
  const message = `مرحبًا، أريد طلب ${product.title} — اللون: ${selectedColor} — العنوان: ${address || "سأرسل العنوان لاحقاً"}`;
  return encodeURIComponent(message);
};

// دالة لإنشاء رابط واتساب للمنتج
export const createProductWhatsappUrl = (product, selectedColor, address = "", whatsappNumber = "2130657362317") => {
  const message = createProductWhatsappMessage(product, selectedColor, address);
  return `https://wa.me/${whatsappNumber}?text=${message}`;
};
